export enum TrialPeriodLengthType {
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
}

export class TrialPeriodLength {
  days?: number;
  weeks?: number;
  months?: number;

  constructor(json: any) {
    this.days = json.days ? json.days : undefined;
    this.weeks = json.weeks ? json.weeks : undefined;
    this.months = json.months ? json.months : undefined;
  }
}
